import { firebase } from "../config/configureFirebase";
import { getFunctions, httpsCallable } from "firebase/functions";

export const createDriverStripeAccount = (data) => async (dispatch) => {
  try {
    console.log('=== createDriverStripeAccount action called ===');
    console.log('Data being sent:', data);
    
    const functions = getFunctions(firebase.app, 'us-central1');
    const createDriverStripeAccountFunction = httpsCallable(functions, "createDriverStripeAccount");
    
    console.log('Calling Cloud Function...');
    const response = await createDriverStripeAccountFunction(data);
    
    console.log('Cloud Function response:', response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating Stripe account:", error);
    throw error;
  }
};

export const getLoginLink = (data) => async (dispatch) => {
  try {
    console.log('=== getLoginLink action called ===');
    console.log('Data being sent:', data);
    
    const functions = getFunctions(firebase.app, 'us-central1');
    const getLoginLinkFunction = httpsCallable(functions, "getLoginLink");
    
    console.log('Calling Cloud Function...');
    const response = await getLoginLinkFunction(data);
    
    console.log('Cloud Function response:', response.data);
    return response.data;
  } catch (error) {
    console.error("Error getting login link:", error);
    throw error;
  }
};

export const getDriverStripeBalance = () => async (dispatch) => {
  try {
    const functions = getFunctions(firebase.app, "us-central1");
    const fn = httpsCallable(functions, "getDriverStripeBalance");
    const res = await fn({});
    return res.data;
  } catch (err) {
    console.error("getDriverStripeBalance error:", err);
    throw err;
  }
};

export const transferToDriverStripeAccount = (data) => async (dispatch) => {
  try {
    const functions = getFunctions(firebase.app, "us-central1");
    const fn = httpsCallable(functions, "transferToDriverStripeAccount");
    const res = await fn(data);
    return res.data;
  } catch (err) {
    console.error("transferToDriverStripeAccount error:", err);
    throw err;
  }
};

// Llama las 3 funciones en orden y regresa su resultado
export const callAllStripeTests = (uid) => async (dispatch) => {
  const results = {};
  results.createDriverStripeAccount = await dispatch(createDriverStripeAccount({ uid }));
  results.getLoginLink = await dispatch(getLoginLink({}));
  return results;
};
